import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import './GoogleLogin.css';
import googleIcon from '../../assets/google-icon.svg';

const GoogleLogin = () => {
    const navigate = useNavigate();
    const { setIsAuthenticated, setUser } = useContext(AuthContext);

    const handleGoogleLogin = async () => {
        // Rediriger vers l'API de Google Login
        // Cette partie doit être complétée selon votre implémentation Google OAuth
        window.location.href = `${process.env.REACT_APP_API_BASE_URL}/auth/google`;
    };

    // Note: Cette fonction serait appelée après un retour réussi de Google OAuth
    // et devrait être implémentée dans une route dédiée
    const handleGoogleCallback = async (token) => {
        if (token) {
            localStorage.setItem('token', token);
            setIsAuthenticated(true);
            try {
                const userResponse = await fetch('/user_info');
                const userData = await userResponse.json();
                setUser(userData);
                navigate('/create');
            } catch (error) {
                console.error('Error fetching user data after Google login', error);
            }
        }
    };

    return (
        <button 
            className="google-login-button" 
            onClick={handleGoogleLogin}
        >
            <div className="google-icon-wrapper">
                <img src={googleIcon} alt="Google" className="google-icon"/>
            </div>
            <span className="google-button-text">Sign in with Google</span>
        </button>
    );
};

export default GoogleLogin; 